import { createSlice } from "@reduxjs/toolkit";
import { changeBugReportStatusThunk, fetchBugReportsThunk } from "./bugReportsThunk";

const initialState = {
    items: [],
    total: 0,
    totalPages: 0,
    loading: false,
    statusChanging: false,
    hasMore: true,
    error: null,
    page: 1
};

export const allProductsSlice = createSlice({
    name: "bug-reports",
    initialState,
    reducers: {
        setPage: (state, action) => {
            state.page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBugReportsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBugReportsThunk.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload;
                state.items = action.payload;
                state.total = data.totalElements;
                state.totalPages = data.totalPages;
                state.hasMore = !data.last;
            })
            .addCase(fetchBugReportsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(changeBugReportStatusThunk.pending, (state) => {
                state.statusChanging = true;
                state.error = null;
            })
            .addCase(changeBugReportStatusThunk.fulfilled, (state, action) => {
                state.statusChanging = false;
                const { id, status } = action.payload;
                state.items = state.items.map((item) => {
                    if (Number(item.id) === Number(id)) {
                        return { ...item, statusType: status };
                    }
                    return item;
                });
            })
            .addCase(changeBugReportStatusThunk.rejected, (state, action) => {
                state.statusChanging = false;
                state.error = action.payload;
            })
    }
});

export const { hydrate, resetAllProducts, removeItem, removeItems, setPage } =
    allProductsSlice.actions;
export default allProductsSlice.reducer;
